// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Get Quote Call-to-action
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

function stickySocial(showMarkers) {
  let matchMedia = gsap.matchMedia();

  matchMedia.add("(min-width: 1200px)", () => {
    ScrollTrigger.create({
      trigger: ".social-sticky",
      start: "top top",
      endTrigger: ".blog-content-section",
      end: "bottom-=170",
      pin: ".social-sticky",
      pinSpacing: false,
      markers: showMarkers,
      toggleClass: "red",
    });
  });
}

export { stickySocial };
